import { Link } from "react-router-dom";
import { categories, works } from "@/mocks/comics";
import SectionHeading from "@/components/feature/SectionHeading";

const ICONS: Record<string, string> = {
  热血冒险: "ri-fire-fill",
  奇幻魔法: "ri-sparkling-2-fill",
  科幻未来: "ri-rocket-2-fill",
  都市青春: "ri-building-4-fill",
  悬疑推理: "ri-focus-3-line",
  温馨治愈: "ri-heart-3-fill",
  恋爱: "ri-heart-pulse-line",
  搞笑日常: "ri-emotion-laugh-fill",
};

export default function CategorySection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="题材分类"
          title="按题材挑选你的下一部漫画"
          desc="丰富的分类体系，从热血到治愈，从科幻到恋爱，总能找到合你口味的故事。"
        />

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {categories.slice(1).map((c) => {
            const count = works.filter((w) => w.category === c.key).length;
            return (
              <Link
                key={c.key}
                to={`/works?cat=${encodeURIComponent(c.key)}`}
                className="group flex items-center gap-4 rounded-xl bg-background-100 p-5 ring-1 ring-background-200 transition-colors hover:ring-primary-300"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={ICONS[c.key] || "ri-book-2-line"} aria-hidden="true" />
                </span>
                <span>
                  <span className="block font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                    {c.label}
                  </span>
                  <span className="text-xs text-foreground-500">{count} 部作品</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}